var fn = function( obj ){
var __t,__p='';
__p+='\n#ifndef _H_OCTWRAP_DECODE_\n#define _H_OCTWRAP_DECODE_\n\nvec2 octwrapDecode( vec3 v ) {\n  // Project the sphere onto the octahedron, and then onto the xy plan\n  vec2 p = v.xy / dot(  abs( v ) , vec3(1.0) );\n  p = vec2( p.x+p.y-1.0, p.x-p.y );\n\n  if( v.z < 0.0 )\n    p.x *= -1.0;\n\n  // p.x *= sign( v.z );\n  return p;\n}\n\n#endif';
return __p;
};
fn.toString=fn;
module.exports = fn;